const Uri = "short/content/Iran40Years/";
const Prof = "?prof=2.New-Iran40Years";
const Category = "Iran40Years";

const VirtualPageview = (url, title) => {
    window.dataLayer.push({
        'event': 'virtualPageview',
        'virtualPageURL': url,
        'virtualPageTitle': title
    });
}

const GA_Event = (action, label) => {
    window.dataLayer.push({
        'event': 'GA_Event',
        'Category': Category,
        'Action': action,
        'Label': label
    });
}

export {
    VirtualPageview,
    GA_Event,
    Prof,
    Uri
}


// WEBPACK FOOTER //
// ./src/Components/Analytics/Analytics.js